define([
	"csi/def",
	"csi/def/Action",
	"csi/def/ActionFactory"
], function(def,Action,ActionFactory) {

	return ActionFactory.declare("refresh", Action, {
		m_id: "ViewRefresh",

		constructor: function(obj) {
			if (!this.m_typeControl) {
				this.setMaterialIcon("refresh");
			}
		}
	});
});